export const translatePills = (translations) => (text) => {
  if (translations && Object.entries(translations).length) {
    const dict = new Map(Object.entries(translations));
    if (/\w+\s\d+$/.test(text)) {
      const [size, number] = text.split(" ");

      return dict.has(size.toLowerCase())
        ? `${dict.get(size.toLowerCase())} ${number}`
        : text;
    }

    return dict.get(text.toLowerCase().trim().replace(" ", "_")) || text;
  }

  return text;
};
